import template from './site-map.html';
import {ComponentBase} from "../Common/componentBase";
import {RegisterDefaultComponent} from "../Common/componentsHelpers";
import { SiteMapService } from "../Http/SiteMap/SiteMapService";
import { AccountsService } from "../Http/Accounts/AccountsService";

export class SiteMapViewModel extends ComponentBase {
    constructor(params) {
        super(params);

        this.urls = ko.observableArray();
        this.siteMapService = new SiteMapService();
        this.accountService = new AccountsService();
        this.userIsAuthenticated = $.cdh.user.authenticated;
        this.isTaxFormConfigured = ko.observable(false);
        this.searchTerm = ko.observable();
        this.searchResults = ko.observable('');
        this.pageUrls = ko.observableArray();
        this.init();
    }
    toggleSpanElements(show) {
        $('.sitemap li').each(function () {
            const span = $(this).find('span');
            if (span.length > 0) {
                span.toggle(show);
            }
        });
    }

    searchMenu(data, event) {
        const searchValue = event.target.value.toLowerCase();
        const noResultsElement = $('.no-results');
        const sitemapItems = $('.sitemap li');
        if (searchValue.length < 3) {
            this.urls(this.pageUrls());
            noResultsElement.hide();
            sitemapItems.show();
            this.toggleSpanElements(true);

        }
        else {
            let found = false;
            sitemapItems.each(function () {
                const link = $(this).find('a');
                const span = $(this).find('span');
                if (link.length > 0 && !span.length > 0) {
                    var text = $(this).find('a').text().toLowerCase();
                    var keywords = $(this).attr('data-keywords') || "";
                    if (text.includes(searchValue) || keywords.includes(searchValue)) {
                        $(this).show();
                        found = true;
                    }
                    else {
                        $(this).hide();
                    }
                }
                else if (span.length > 0) {
                    span.hide();
                }
            });
            if (!found) {
                noResultsElement.show();
            } else {
                noResultsElement.hide();
            }
        }
    };

    async init() {
        let result = await this.siteMapService.getUrlsAsync();

        // Need to check whether TaxForms URL is configured or not in CMS
        const taxFormsUrlExist = result.data().filter(item => Array.isArray(item.Children)).map(item => {
            return {
                ...item,
                Children: item.Children.filter(child => child.Url && child.Url.includes('accoutId=0'))
            };
        }).filter(item => item.Children.length > 0).length > 0;

        this.isTaxFormConfigured(taxFormsUrlExist);

        this.removeTaxFormsUrl = (result) => {
            let exceptTaxfomsArray = result.data().map(
                item => {
                    if (item.Children && Array.isArray(item.Children)) {
                        item.Children = item.Children.filter(child => !child.Url || !child.Url.includes('accoutId=0'));
                    }
                    return item;
                });
            this.urls(exceptTaxfomsArray);
        }

        if (this.isTaxFormConfigured() && this.userIsAuthenticated && !$.cdh.user.isAnonymousEnrollmentUser) {
            this.accountService.getListHsaAsync($.cdh.enums.planYear.all).then((accounts) => {
                if (accounts && accounts.length > 0) {
                    let filteredHSAAccounts = accounts.filter(ac => ac.IsHsa == true && ac.IsVeba == false);
                    if (filteredHSAAccounts.length > 0) {
                        let sortedHSAAccountList = filteredHSAAccounts.sort((a, b) => a.Priority - b.Priority);
                        let urlsArray = result.data();
                        urlsArray.forEach(
                            item => {
                                if (item.Children && Array.isArray(item.Children)) {
                                    item.Children.forEach(child => {
                                        if (child.Url && child.Url.includes('accoutId=0')) {
                                            child.Url = child.Url.replace('accoutId=0', 'accountId=' + sortedHSAAccountList[0].AccountId);
                                        }
                                    });
                                }
                            }
                        );
                        this.urls(urlsArray);
                    }
                    else {
                        this.removeTaxFormsUrl(result);
                    }
                }       
                else {
                    this.removeTaxFormsUrl(result);
                }
                recalcWidgetsHeights();
            });
        } else {
            this.urls(result.data());
            this.pageUrls(result.data());
            recalcWidgetsHeights();
        }
    }
}

RegisterDefaultComponent('site-map', template, SiteMapViewModel);